<template>
  <div
    v-if="config !== undefined">
    <v-flex
      xs12
      md4
      lg4>
      <v-select
        v-model="protocol"
        :items="protocols"
        :label="`${ $t('Protocol on COM{0}', [portSettings.port]) }`"
        data-testId="select-Protocol-on-COM"
        item-text="desc"
        item-value="code"
        class="dover-input"
        chips
        @change="onChange()">
        <template
          slot="selection"
          slot-scope="data">
          <v-chip
            :selected="data.selected"
            :disabled="data.disabled"
            :key="data.item.code"
            data-testId="chip"
            class="v-chip--select-multi "
            @input="data.parent.selectItem(data.item)">
            <v-avatar class="dover-avatar ">{{ data.item.code }}</v-avatar>
            {{ data.item.desc }}
          </v-chip>
        </template>
      </v-select>
    </v-flex>
    <v-flex
      xs6
      md2
      lg2>
      <v-select
        v-model="config.baudRate"
        :items="baudRates"
        :label="`${ $t('Baud rate') }`"
        data-testId="select-Baud-rate"
        item-text="desc"
        item-value="code"
        class="dover-input"
        chips
        @change="onChange()">
        <template
          slot="selection"
          slot-scope="data">
          <v-chip
            :selected="data.selected"
            :disabled="data.disabled"
            :key="data.item.code"
            data-testId="chip-2"
            class="v-chip--select-multi "
            @input="data.parent.selectItem(data.item)">
            <v-avatar class="dover-avatar ">{{ data.item.code }}</v-avatar>
            {{ data.item.desc }}
          </v-chip>
        </template>
      </v-select>
    </v-flex>
    <v-flex
      xs6
      md2
      lg2>
      <v-select
        v-model="config.parity"
        :items="parity"
        :label="`${ $t('Parity') }`"
        data-testId="select-Parity"
        item-text="desc"
        item-value="code"
        class="dover-input"
        chips
        @change="onChange()">
        <template
          slot="selection"
          slot-scope="data">
          <v-chip
            :selected="data.selected"
            :disabled="data.disabled"
            :key="data.item.code"
            data-testId="chip-3"
            class="v-chip--select-multi "
            @input="data.parent.selectItem(data.item)">
            <v-avatar class="dover-avatar ">{{ data.item.code }}</v-avatar>
            {{ data.item.desc }}
          </v-chip>
        </template>
      </v-select>
    </v-flex>
    <v-flex
      xs6
      md2
      lg2>
      <v-select
        v-model="config.dataBit"
        :items="dataBits"
        :label="`${ $t('Data bit') }`"
        data-testId="select-Data-bit"
        item-text="desc"
        item-value="code"
        class="dover-input"
        chips
        @change="onChange()">
        <template
          slot="selection"
          slot-scope="data">
          <v-chip
            :selected="data.selected"
            :disabled="data.disabled"
            :key="data.item.code"
            data-testId="chip-4"
            class="v-chip--select-multi "
            @input="data.parent.selectItem(data.item)">
            <v-avatar class="dover-avatar ">{{ data.item.code }}</v-avatar>
            {{ data.item.desc }}
          </v-chip>
        </template>
      </v-select>
    </v-flex>
    <v-flex
      xs6
      md2
      lg2>
      <v-select
        v-model="config.stopBit"
        :items="stopBits"
        :label="`${ $t('Data bit') }`"
        data-testId="select-Data-bit-2"
        item-text="desc"
        item-value="code"
        class="dover-input"
        chips
        @change="onChange()">
        <template
          slot="selection"
          slot-scope="data">
          <v-chip
            :selected="data.selected"
            :disabled="data.disabled"
            :key="data.item.code"
            data-testId="chip-5"
            class="v-chip--select-multi "
            @input="data.parent.selectItem(data.item)">
            <v-avatar class="dover-avatar ">{{ data.item.code }}</v-avatar>
            {{ data.item.desc }}
          </v-chip>
        </template>
      </v-select>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: {
    isValidationOk: {
      type: Boolean,
      required: true,
      default: () => []
    },
    protocols: {
      type: Array,
      required: true,
      default: () => {}
    },
    portSettings: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    config: undefined,
    baudRates: [],
    parity: [],
    dataBits: [],
    stopBits: []
  }),
  mounted () {
    this.baudRates.push({ code: '9600', desc: '9600' })
    this.baudRates.push({ code: '4800', desc: '4800' })
    this.baudRates.push({ code: '2400', desc: '2400' })
    this.baudRates.push({ code: '1200', desc: '1200' })

    this.parity.push({ code: 'N', desc: this.$t('None') })
    this.parity.push({ code: 'O', desc: this.$t('Odd') })
    this.parity.push({ code: 'E', desc: this.$t('Even') })

    this.dataBits.push({ code: '8', desc: '8' })
    this.dataBits.push({ code: '7', desc: '7' })

    this.stopBits.push({ code: '1', desc: '1' })
    this.stopBits.push({ code: '2', desc: '2' })

    let value = this.portSettings.configuration.split(',')
    this.config.port = this.portSettings.port
    this.config.protocol = this.portSettings.protocol
    this.config.baudRate = value[0]
    this.config.parity = value[1]
    this.config.dataBit = value[2]
    this.config.stopBit = value[3]
  },
  methods: {
    onChange () {
      let newConfig = {
        port: this.config.port,
        protocol: this.config.protocol,
        configuration: this.config.baudRate + ',' + this.config.parity + ',' + this.config.dataBit + ',' + this.config.stopBit
      }

      this.$emit('onProtocolChange', newConfig)
    }
  }
}
</script>
